import React, { useRef, useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Button } from "@/components/ui/button";

const V = 300; // viewport size
const OUT = 512; // output size

export function ImageCropper({ open, onOpenChange, file, onCropped }) {
  const [img, setImg] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [posX, setPosX] = useState(50);
  const [posY, setPosY] = useState(50);

  useEffect(() => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => { setImg(image); setZoom(1); setPosX(50); setPosY(50); };
    image.src = url;
    return () => URL.revokeObjectURL(url);
  }, [file]);

  if (!img) return null;
  const base = V / Math.min(img.naturalWidth, img.naturalHeight);
  const dispW = img.naturalWidth * base * zoom;
  const dispH = img.naturalHeight * base * zoom;
  const left = (V - dispW) * (posX / 100);
  const top = (V - dispH) * (posY / 100);

  const save = () => {
    const canvas = document.createElement("canvas");
    canvas.width = OUT; canvas.height = OUT;
    const ctx = canvas.getContext("2d");
    const f = OUT / V;
    ctx.drawImage(img, left * f, top * f, dispW * f, dispH * f);
    canvas.toBlob((blob) => {
      const out = new File([blob], "avatar.jpg", { type: "image/jpeg" });
      onCropped(out);
      onOpenChange(false);
    }, "image/jpeg", 0.9);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-4 border-black bg-spotter-cream" data-testid="avatar-cropper">
        <DialogHeader><DialogTitle className="font-heading text-xl text-spotter-maroon">Crop your photo</DialogTitle></DialogHeader>
        <div className="flex justify-center">
          <div className="relative overflow-hidden border-2 border-black rounded-full bg-black" style={{ width: V, height: V }}>
            <img src={img.src} alt="crop" style={{ position: "absolute", width: dispW, height: dispH, left, top, maxWidth: "none" }} />
          </div>
        </div>
        <div className="space-y-3 px-1">
          <div><Label>Zoom</Label><Slider data-testid="crop-zoom" value={[zoom]} onValueChange={(v) => setZoom(v[0])} min={1} max={3} step={0.01} className="mt-2" /></div>
          <div><Label>Horizontal</Label><Slider data-testid="crop-x" value={[posX]} onValueChange={(v) => setPosX(v[0])} min={0} max={100} step={1} className="mt-2" /></div>
          <div><Label>Vertical</Label><Slider data-testid="crop-y" value={[posY]} onValueChange={(v) => setPosY(v[0])} min={0} max={100} step={1} className="mt-2" /></div>
        </div>
        <DialogFooter>
          <Button data-testid="crop-save" onClick={save} className="bg-spotter-maroon text-spotter-cream border-2 border-black">Crop & Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
